<template>
  <div class="sn-f-b-s price-detail">
    <sn-navigator id="WJCX" :initial="perpetual.FUNCTION_ID_WJCX"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s price-detail-region">
      <sn-breadcrumb :breadcrumb="[{ title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_WJCX) }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 price-blank">
        <template v-if="!$sn.validate.empty(showList)">
          <!-- <div class="total-title">消费总金额：{{$sn.format.priceFormat(totalCost, 2)}}元</div> -->
          <div class="sn-table">
            <table>
              <thead>
                <tr>
                  <!-- <th>序号</th> -->
                  <th>名称</th>
                  <th>厂商</th>
                  <th>规格</th>
                  <th>单价（元）</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(obj, index) in showList">
                  <!-- <td>{{ index + 1 }}</td> -->
                  <td>{{obj.medicineName}}</td>
                  <td>{{obj.factory}}</td>
                  <td>{{obj.unit}}</td>
                  <td>{{obj.price === 0 ? '0.00' : $sn.format.priceFormat(obj.price, 2)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-else>
          <sn-no-data></sn-no-data>
          <!-- <div class="sn-f-c-c prompt-message">请输入所要查询信息的首字母拼写进行查询</div> -->
        </template>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script type="text/javascript">
import * as Constants from '@/common/utils/constants';
// import * as Messages from '@/common/utils/messages';

export default {
  data() {
    return {
      perpetual: Constants,
      queryType: null, // 查询类型
      keyWord: '', // 关键字
      showList: [], // 元数据列表
      pageCount: 1,
      isResult: true,
      exhibitionCreatePatient: false,
      exhibitionBindCard: false
    };
  },
  created() {
    this.funLoad();
  },
  methods: {
    async funLoad() {
      document.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_MZBG);
      this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_MZBG);
      this.showList = this.$sn.utils.getHospitalSessionStorage('price_Info') || [];
    }
  }
};
</script>
<style lang="scss" scoped>
.price-detail {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: $white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  &-region {
    overflow: hidden;
    height: 100%;

    .price-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding-right: 20px;
      display: flex;
      flex-direction: column;
      margin-top: 20px;

      ::v-deep .sn-header-patient {
        .el-date-editor.el-input {
          width: 130px;
        }

        .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
      }

      .el-button {
        padding: 10px 20px;
        background-color: $main1;
        border-color: $main1;
      }

      .total-title {
        font-size: 16px;
        margin: 0 20px 20px;
      }

      .prompt-message {
        font-size: 16px;
        color: $red1;
        padding: 10px 0;
      }
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
